import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginForm from './Components/LoginForm';
import ErrorNotFound from './ErrorNotFound';
import HomeLayout from './Components/HomeLayout';
import Splash from './Components/splash';
import DynamicForm from './Components/tasks/DynamicForm';
import Task2UserStories from './Components/tasks/Task2UserStories';
import Content from './Components/Content';
import BottomBar from './Components/BottomBar';
import FormHeader from './Components/tasks/FormHeader';


const App = () => {
  const [isLoggedIn, setLoggedIn] = useState(false);

  const authenticateUser = (enteredUsername, enteredPassword) => {
    // Hardcoded user credentials
    const users = [
      { username: 'admin', password: '72565123' },
      { username: 'user1', password: 'password1' },
      { username: 'user2', password: 'password2' },
      { username: 'user3', password: 'password3' },
      { username: 'user4', password: 'password4' },
      { username: 'user5', password: 'password5' },
    ];

    // Check if the entered credentials match any user
    const user = users.find(u => u.username === enteredUsername && u.password === enteredPassword);

    if (user) {
      setLoggedIn(true);
      return true;
    } else {
      return false;
    }
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginForm authenticateUser={authenticateUser} />} />
        <Route path="/task1" element={
          <><FormHeader/><DynamicForm authenticateUser={authenticateUser} /></>
        } />
                <Route path="/task1" element={
          <><FormHeader/><DynamicForm authenticateUser={authenticateUser} /></>
        } />

        <Route
          path="/add-userstory"
          element={
            <Task2UserStories authenticateUser={authenticateUser}><Task2UserStories /></Task2UserStories>
          }
        />
        <Route
          path="/home"
          element={ <HomeLayout authenticateUser={authenticateUser} showContent={'show'} ShowNextButtons={'show'}></HomeLayout>
          }
        />
        <Route path="*" element={<ErrorNotFound />} />
      </Routes>
    </Router>
  );
};

export default App;